var base = {
	'color1' : { //Events
		'base' : '#df77e9',
		'dark' : '#63136c',
		'lite' : '#f9cdff'
	},

	'color2' : { //Education
		'base' : '#4dd2ff',
		'dark' : '#1E86A9',
		'lite' : '#d1efff'
	},

	'color3' : { //Initiatives
		'base' : '#ff9673',
		'dark' : '#852c17',
		'lite' : '#fdddd3'
	},

	'color4' : { //Theater
		'base' : '#68bb66',
		'dark' : '#358b2f',
		'lite' : '#d3ffd0'
	}
}

module.exports = {
	'comb1' : {
		'start': base.color1.base,
		'end': base.color2.base
	},
	'comb2' : {
		'start': base.color2.dark,
		'end': base.color3.dark
	},
	'comb3' : {
		'start': base.color3.dark,
		'end': base.color1.dark
	},
	'comb4' : {
		'start': base.color4.dark,
		'end': base.color2.dark
	}
}


//////////////////
// WEBPACK FOOTER
// ./scripts/colors.js
// module id = 11
// module chunks = 0